import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { crmRoutingModule } from './crm-routing.module';
import {CommmonPipeModule} from '@fitness-force/pipes/common-pipes';




@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    crmRoutingModule,
    CommmonPipeModule
  ],
  providers: [ DatePipe]
})
export class CRMModule { }
